import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=2b52c3b6&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b52c3b6')) {
      api.createRecord('2b52c3b6', component.options)
    } else {
      api.reload('2b52c3b6', component.options)
    }
    module.hot.accept("./youtube-video.vue?vue&type=template&id=2b52c3b6&", function () {
      api.rerender('2b52c3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kcVIQZ1h51P7/JS/youtube-video.vue"
export default component.exports